<template>
    <v-dialog v-model="modalProp" max-width="1300">
        <v-card>
            <v-card-title class="white">
                <v-row>
                    <div class="col-10" style="font-size:small;">
                        <span class="green--text"><b>{{ hospital }}</b></span>
                    </div>
                    <div class="col-2 d-flex justify-end">
                        <v-btn icon @click="modalProp = false">
                            <v-icon>{{ mdiClose }}</v-icon>
                        </v-btn>
                    </div>
                </v-row>
            </v-card-title>
            <v-divider />
            <v-data-table
                :headers="headers"
                :items="diagData"
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, -1],
                    'items-per-page-text': ''
                }"
            />
        </v-card>
    </v-dialog>
</template>
<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['hospital', 'hospitalData', 'show'],
    data() {
        return {
            mdiClose,
            headers: [
                {
                    text: 'Doctor',
                    sortable: true,
                    value: 'doc_name'
                },
                {
                    text: 'Schedule',
                    sortable: false,
                    value: 'af_sched'
                },
                {
                    text: 'Room Number',
                    sortable: false,
                    value: 'af_roomno'
                },
                {
                    text: 'Specialization',
                    sortable: true,
                    value: 'specialization'
                }
            ]
        }
    },
    computed: {
        modalProp: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('showDialogProp', val)
            }
        },
        diagData: {
            get() {
                return this.diagArr()
            }
        }
    },
    methods: {
        diagArr() {
            let diagArr = []
            for (let i = 0; i < (this.hospitalData).length; i++) {
                (this.hospitalData)[i].specialization = this.wrapSpecializations((this.hospitalData)[i])
                diagArr.push((this.hospitalData)[i])
            }

            return diagArr
        },
        wrapSpecializations({ doc_specialization_1, doc_specialization_2, doc_specialization_3 }) {

            let spec_str = []

            if(doc_specialization_1 !== null && String(doc_specialization_1).trim() !== '') spec_str.push(String(doc_specialization_1).trim())
            if(doc_specialization_2 !== null && String(doc_specialization_2).trim() !== '') spec_str.push(String(doc_specialization_2).trim())
            if(doc_specialization_3 !== null && String(doc_specialization_3).trim() !== '') spec_str.push(String(doc_specialization_3).trim())

            let str = ''
            for (let i = 0; i < spec_str.length; i++) {
                str += spec_str[i]
                if(i < spec_str.length - 1) {
                    str += ' - '
                }
            }

            return str

        }
    }
}
</script>
